import { RoutablePage, configQuery, uniqueValues } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __assign, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { store } from '../../store/index.js';
import '../../mixins/static-page.mixin.js';
import { PromotionsMixin } from '../../mixins/promotions.mixin.js';
import '../../mixins/landing-page.mixin.js';
import { CompetitionsMixin } from '../../mixins/competitions.mixin.js';

var ALL_PROMOTIONS_ID = 'all';
/**
 * Displays list of promotions grouped in categories
 */
var PromotionsComponent = /** @class */ (function (_super) {
    __extends(PromotionsComponent, _super);
    function PromotionsComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.visibleCategories = false;
        _this.hiddenCategories = [];
        _this.activeTab = ALL_PROMOTIONS_ID;
        _this.depositLink = RoutablePage.WALLET_DEPOSIT;
        return _this;
    }
    PromotionsComponent.prototype.created = function () {
        this.getDepositLink();
    };
    PromotionsComponent.prototype.getDepositLink = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isSweepstakes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, configQuery('sweepstakes')];
                    case 1:
                        isSweepstakes = _a.sent();
                        this.depositLink = isSweepstakes
                            ? RoutablePage.SWEEPSTAKES_SHOP
                            : RoutablePage.WALLET_DEPOSIT;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(PromotionsComponent.prototype, "depositRoutablePage", {
        get: function () {
            return this.depositLink;
        },
        set: function (value) {
            this.depositLink = value;
        },
        enumerable: false,
        configurable: true
    });
    PromotionsComponent.prototype.setAllCategoriesVisible = function () {
        this.visibleCategories = this.categoriesWithPromotions.map(function (category) {
            return category.title === 'landing' ? '' : category.id;
        });
    };
    PromotionsComponent.prototype.setVisibleCategories = function (category) {
        if (category === ALL_PROMOTIONS_ID) {
            this.setAllCategoriesVisible();
            return;
        }
        this.visibleCategories = [category];
    };
    PromotionsComponent.prototype.toggleVisibleCategories = function (value) {
        if (!this.visibleCategories) {
            // if visibleCategories is set to false populate it with all the categories
            var categories = this.promotionsWithCategory.map(function (_a) {
                var category = _a.category;
                return category.id;
            });
            this.visibleCategories = categories;
        }
        if (this.visibleCategories.includes(value)) {
            this.visibleCategories = this.visibleCategories.filter(function (category) { return category !== value; });
            return;
        }
        this.visibleCategories.push(value);
    };
    Object.defineProperty(PromotionsComponent.prototype, "promotionsWithCategory", {
        get: function () {
            var _this = this;
            if (!this.promotions || !this.categories) {
                return [];
            }
            var promotionsWithCategory = this.categories.reduce(function (acc, category) {
                var _a;
                return (__assign(__assign({}, acc), (_a = {}, _a[category.id] = { category: category, promotions: [] }, _a)));
            }, {});
            this.promotions.forEach(function (promotion) {
                var catId = promotion.catId;
                if (!catId || !promotionsWithCategory[catId]) {
                    return;
                }
                promotionsWithCategory[catId].promotions.push(promotion);
            });
            return Object.values(promotionsWithCategory)
                .filter(function (item) {
                return item.promotions.length > 0;
            })
                .map(function (item) {
                return __assign(__assign({}, item), { category: __assign(__assign({}, item.category), { visible: _this.visibleCategories
                            ? _this.visibleCategories.includes(item.category.id)
                            : true }) });
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromotionsComponent.prototype, "categoriesWithPromotions", {
        /**
         * Returns an array of categories that have promotions
         */
        get: function () {
            var categoriesWithPromotions = uniqueValues(this.promotions.map(function (_a) {
                var catId = _a.catId;
                return catId;
            }));
            return this.categories.filter(function (category) {
                return categoriesWithPromotions.includes(category.id);
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromotionsComponent.prototype, "collapsibleItems", {
        get: function () {
            if (!this.promotions || !this.categories) {
                return [];
            }
            var items = this.categoriesWithPromotions.map(function (category) { return ({
                name: category.title,
                slug: category.id,
            }); });
            return [
                {
                    name: this.$t('promotions.all.button'),
                    slug: ALL_PROMOTIONS_ID,
                },
            ].concat(items);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromotionsComponent.prototype, "hiddenCategoryOptions", {
        get: function () {
            return this.hiddenCategories.map(function (_a) {
                var name = _a.name, slug = _a.slug;
                return ({
                    name: name,
                    value: slug,
                });
            });
        },
        enumerable: false,
        configurable: true
    });
    PromotionsComponent.prototype.setHiddenCategories = function (hidden) {
        this.hiddenCategories = hidden;
    };
    /**
     * Tag is the first promotion type not being current filter
     */
    PromotionsComponent.prototype.getTag = function (promotion) {
        var _this = this;
        if (!promotion || !promotion.types) {
            return '';
        }
        var tag = promotion.types.find(function (type) { return type !== _this.type; });
        if (!tag) {
            return '';
        }
        return this.$t("promotions.tag." + tag);
    };
    PromotionsComponent.prototype.selectCategory = function (e) {
        this.activeTab = e.detail[0];
        this.setVisibleCategories(e.detail[0]);
    };
    PromotionsComponent.prototype.openAccordion = function (id) {
        this.activeTab = '';
        this.toggleVisibleCategories(id);
    };
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], PromotionsComponent.prototype, "alignCategoriesLeft", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], PromotionsComponent.prototype, "hideCategoriesSelector", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], PromotionsComponent.prototype, "hideAccordionToggle", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], PromotionsComponent.prototype, "topNavigation", void 0);
    PromotionsComponent = __decorate([
        Component({
            name: 'promotions',
            store: store,
        })
    ], PromotionsComponent);
    return PromotionsComponent;
}(Mixins(PromotionsMixin, CompetitionsMixin)));

export default PromotionsComponent;
